import { CircularProgress, Stack, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useMerchantByIdQuery } from '../../api/hooks/merchants';
import Catalogs from '../Catalogs/CatalogsTable';

const MerchantView = () => {
  const { merchantId } = useParams();
  const { data, isLoading } = useMerchantByIdQuery({ merchantId });

  if (isLoading || !data) return <CircularProgress />;

  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="h1">{data.name}</Typography>
        <Typography variant="caption" textTransform="capitalize">
          {data.provider} Merchant ID: {data.merchant_id}
        </Typography>
      </Stack>
      <Stack mb={4} justifyContent="end">
        <Typography variant="caption">
          {data.address.street_address}
          <br /> {data.address.locality}, {data.address.region},{' '}
          {data.address.country} {data.address.postal_code}
        </Typography>
      </Stack>
      <Catalogs />
    </>
  );
};

export default MerchantView;
